import { render, staticRenderFns } from "./presentation-element-container.vue?vue&type=template&id=a971ae2a&"
import script from "./presentation-element-container.vue?vue&type=script&lang=js&"
export * from "./presentation-element-container.vue?vue&type=script&lang=js&"
import style0 from "./presentation-element-container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports